// Piecrip 이미지 경로 매핑
// Figma에서 다운로드한 이미지들을 로컬 경로로 매핑
// Vite에서는 직접 import하는 방식을 사용

// 배경 이미지
import heroBg from './backgrounds/hero-bg.svg';
import heroBgDark from './backgrounds/hero-bg-dark.svg';
import footerBg from './backgrounds/footer-bg.svg';
import footerBgDark from './backgrounds/footer-bg-dark.svg';
import welcomeBonusBg from './backgrounds/welcome-bonus-bg.svg';
import welcomeBonusBgDark from './backgrounds/welcome-bonus-bg-dark.svg';
import journeyPlanets from './backgrounds/journey-planets.svg';
import tradeSeamlesslyBg from './backgrounds/trade-seamlessly-bg.svg';
import marketHeroStars from './backgrounds/market-hero-stars.svg';
import marketHeroOrbital from './backgrounds/market-hero-orbital.svg';
import marketHeroAstronaut from './backgrounds/market-hero-astronaut.svg';
import vipSupportPlanetsBg from './backgrounds/vip-support-planets-bg.svg';
import membershipTierGalaxyLayer1 from './backgrounds/membership-tier-galaxy-layer1.svg';
import membershipTierGalaxyLayer2 from './backgrounds/membership-tier-galaxy-layer2.svg';
import membershipTierPlanetsBg from './backgrounds/membership-tier-planets-bg.svg';
import membershipTierUnion from './backgrounds/membership-tier-union.svg';
import requirementsTableUnion from './images/requirements-table-union.svg';
import crystalGloss from './images/crystal-gloss.svg';
import crystalStone from './images/crystal-stone.svg';

// 크립토 아이콘
import btcIcon from './icons/crypto/btc.svg';
import ethIcon from './icons/crypto/eth.svg';
import xrpIcon from './icons/crypto/xrp.svg';
import solIcon from './icons/crypto/sol.svg';
import dogeIcon from './icons/crypto/doge.svg';

// UI 아이콘
import messageIcon from './icons/ui/message.svg';
import searchIcon from './icons/ui/search.svg';
import userIcon from './icons/ui/user.svg';
import languageIcon from './icons/ui/language.svg';
import downloadIcon from './icons/ui/download.svg';
import lightModeIcon from './icons/ui/light-mode.svg';
import darkModeIcon from './icons/ui/dark-mode.svg';
import settingsIcon from './icons/ui/settings.svg';
import settingsDarkIcon from './icons/ui/settings-dark.svg';
import nightModeIcon from './icons/ui/night-mode.svg';
import arrowIcon from './icons/ui/arrow.svg';
import checkIcon from './icons/ui/check.svg';
import qrCodeIcon from './icons/ui/qr-code.svg';
import myRewardsIcon from './icons/ui/my-rewards-icon.svg';
import starIcon from './icons/ui/star.svg';
import checkBigIcon from './icons/ui/check-big.svg';
import checkBigWhiteIcon from './icons/ui/check-big-white.svg';
import faqCheckIcon from './icons/ui/faq-check-icon.svg';
import faqLines from './icons/ui/faq-lines.svg';
import vipDiamondIcon from './icons/ui/vip-diamond-icon.svg';
import emailIcon from './icons/ui/email-icon.svg';
import buildingIcon from './icons/ui/building-icon.svg';
import chatIcon from './icons/ui/chat-icon.svg';
import hamburgerMenuIcon from './icons/ui/hamburger-menu.svg';
import graphLineIcon from './icons/ui/graph-line.svg';
import arrowRightSmallIcon from './icons/ui/arrow-right-small.svg';
import chevronRightIcon from './icons/ui/chevron-right.svg';
import arrowRightCyanIcon from './icons/ui/arrow-right-cyan.svg';
import scrollArrowIcon from './icons/ui/scroll-arrow.svg';
import supportIcon from './icons/ui/support.svg';
import scrollUpIcon from './icons/ui/scroll-up.svg';

// 네비게이션 아이콘
import arrowRightIcon from './icons/navigation/arrow-right.svg';
import arrowNavIcon from './icons/navigation/arrow-icon.svg';

// 파트너 로고 (다크모드용 - 기존)
import bufferLogo from './logos/partners/buffer.svg';
import pimcoreLogo from './logos/partners/pimcore.svg';
import githubPagesLogo from './logos/partners/github-pages.svg';
import coinbaseLogo from './logos/partners/coinbase.svg';
import dropboxLogo from './logos/partners/dropbox.svg';
import framerLogo from './logos/partners/framer.svg';
import berealLogo from './logos/partners/bereal.svg';
import digitalOceanLogoDark from './logos/partners/digital-ocean-dark.svg';

// 파트너 로고 (라이트모드용)
import bufferLogoLight from './logos/partners/buffer-light.svg';
import pimcoreLogoLight from './logos/partners/pimcore-light.svg';
import githubPagesLogoLight from './logos/partners/github-pages-light.svg';
import coinbaseLogoLight from './logos/partners/coinbase-light.svg';
import dropboxLogoLight from './logos/partners/dropbox-light.svg';
import framerLogoLight from './logos/partners/framer-light.svg';
import berealLogoLight from './logos/partners/bereal-light.svg';
import digitalOceanLogo from './logos/partners/digital-ocean-light.svg';

// 소셜 아이콘
import facebookIcon from './icons/social/facebook.svg';
import facebookBgIcon from './icons/social/facebook-bg.svg';
import facebookOverlayIcon from './icons/social/facebook-overlay.svg';
import xIcon from './icons/social/x.svg';
import instagramIcon from './icons/social/instagram.svg';
import discordIcon from './icons/social/discord.svg';
import youtubeIcon from './icons/social/youtube.svg';
import youtubeBgIcon from './icons/social/youtube-bg.svg';
import youtubeOverlayIcon from './icons/social/youtube-overlay.svg';
import redditIcon from './icons/social/reddit.svg';
import redditBgIcon from './icons/social/reddit-bg.svg';
import redditOverlayIcon from './icons/social/reddit-overlay.svg';
import tiktokIcon from './icons/social/tiktok.svg';
import frame89Icon from './icons/social/frame89.svg';
import whatsappIcon from './icons/social/whatsapp.svg';
import whatsappBgIcon from './icons/social/whatsapp-bg.svg';
import whatsappOverlayIcon from './icons/social/whatsapp-overlay.svg';
import snapchatIcon from './icons/social/snapchat.svg';
import snapchatBgIcon from './icons/social/snapchat-bg.svg';
import snapchatOverlayIcon from './icons/social/snapchat-overlay.svg';
import gamepadBgIcon from './icons/social/gamepad-bg.svg';
import gamepadOverlayIcon from './icons/social/gamepad-overlay.svg';
// 다크모드 소셜 아이콘
import facebookDarkIcon from './icons/social/facebook-dark.svg';
import redditDarkIcon from './icons/social/reddit-dark.svg';
import snapchatDarkIcon from './icons/social/snapchat-dark.svg';
import gamepadDarkIcon from './icons/social/gamepad-dark.svg';
import youtubeDarkIcon from './icons/social/youtube-dark.svg';
import whatsappDarkIcon from './icons/social/whatsapp-dark.svg';

// 스토어 배지
import appStoreBadge from './store-badges/app-store.svg';
import googlePlayBadge from './store-badges/google-play.svg';

// 일러스트레이션
import journeyStep1 from './illustrations/journey-step-1.svg';
import journeyStep2 from './illustrations/journey-step-2.svg';
import journeyStep3 from './illustrations/journey-step-3.svg';
import journeyStep4 from './illustrations/journey-step-4.svg';
import journeyStep5 from './illustrations/journey-step-5.svg';
import journeyBadge from './illustrations/journey-badge.svg';
import trustShield from './illustrations/trust-shield.svg';
import trustShieldDark from './illustrations/trust-shield-dark.svg';
import trustVector1 from './illustrations/trust-vector-1.svg';
import trustVector2 from './illustrations/trust-vector-2.svg';
import trustVector3 from './illustrations/trust-vector-3.svg';
import tradeAcrossChart from './illustrations/trade-across-chart.svg';
import buysellPlanetsBg from './illustrations/buysell-planets-bg.svg';
import buysellCharacter from './illustrations/buysell-character.svg';
import buysellVrDevice from './illustrations/buysell-vr-device.svg';
import toptradersAstronaut from './illustrations/toptraders-astronaut.svg';
import toptradersFlag from './illustrations/toptraders-flag.svg';
import toptradersTrophyLogo from './illustrations/toptraders-trophy-logo.svg';
import toptradersPlanetsBg from './illustrations/toptraders-planets-bg.svg';
import institutionalHeroBg from './illustrations/institutional-hero-bg.svg';
import heroAstronaut from './illustrations/hero-astronaut.svg';
import heroAstronautDark from './illustrations/hero-astronaut-dark.svg';
import heroPlanets from './illustrations/hero-planets.svg';
import chartDots from './illustrations/chart-dots.svg';
import chartDotsDark from './illustrations/chart-dots-dark.svg';
import bonusAstronaut from './illustrations/bonus-astronaut.svg';
import bonusPlanetsBg from './illustrations/bonus-planets-bg.svg';
// Rank 1 assets (Gold - 214x142)
import rank1Ring from './illustrations/rank1-ring.svg';
import rank1Laurel from './illustrations/rank1-laurel.svg';
import rank1Badge from './illustrations/rank1-badge.svg';
import rank1Profile from './illustrations/rank1-profile.svg';
// Rank 2 assets (Silver - 152x101)
import rank2Ring from './illustrations/rank2-ring.svg';
import rank2Laurel from './illustrations/rank2-laurel.svg';
import rank2Badge from './illustrations/rank2-badge.svg';
import rank2Profile from './illustrations/rank2-profile.svg';
// Rank 3 assets (Bronze - 152x101)
import rank3Ring from './illustrations/rank3-ring.svg';
import rank3Laurel from './illustrations/rank3-laurel.svg';
import rank3Badge from './illustrations/rank3-badge.svg';
import rank3Profile from './illustrations/rank3-profile.svg';
// Sentiment 일러스트레이션
import sentimentPlanetsBg from './illustrations/sentiment/planets-bg.svg';
import sentimentCockpitFrame from './illustrations/sentiment/cockpit-frame.svg';
import sentimentCrystal from './illustrations/sentiment/crystal.svg';
import sentimentGaugeSubtractBg from './illustrations/sentiment/gauge-subtract-bg.svg';
import sentimentControlPanelLeft from './illustrations/sentiment/control-panel-left.svg';
import sentimentControlPanelRight from './illustrations/sentiment/control-panel-right.svg';
import sentimentMoonPlanet from './illustrations/sentiment/moon-planet.svg';
import sentimentSmallCrystal from './illustrations/sentiment/small-crystal.svg';
import sentimentGaugeLeftDiamond from './illustrations/sentiment/gauge-left-diamond.svg';
import sentimentGaugeOuterArc from './illustrations/sentiment/gauge-outer-arc.svg';
import sentimentGaugeInnerArc from './illustrations/sentiment/gauge-inner-arc.svg';
import sentimentGaugeRightDiamond from './illustrations/sentiment/gauge-right-diamond.svg';
import sentimentGaugeTopArc from './illustrations/sentiment/gauge-top-arc.svg';
import sentimentGaugeCenterLine from './illustrations/sentiment/gauge-center-line.svg';
import sentimentGaugeLeftSide from './illustrations/sentiment/gauge-left-side.svg';
import sentimentGaugeBottomArc from './illustrations/sentiment/gauge-bottom-arc.svg';
import sentimentGaugeNeedle from './illustrations/sentiment/gauge-needle.svg';
import sentimentBinanceCircle from './illustrations/sentiment/binance-circle.svg';
import sentimentCircleRing from './illustrations/sentiment/circle-ring.svg';
import sentimentLitecoinIcon from './illustrations/sentiment/litecoin-icon.svg';
import sentimentBtcIcon from './illustrations/sentiment/btc-icon.svg';
// Sentiment 그래프
import sentimentPulseFill from './illustrations/sentiment/graphs/sentiment-pulse-fill.svg';
import sentimentPulseLine from './illustrations/sentiment/graphs/sentiment-pulse-line.svg';
import socialMediaBars from './illustrations/sentiment/graphs/social-media-bars.svg';
import moodShiftLines from './illustrations/sentiment/graphs/mood-shift-lines.svg';
// Journey Universe 일러스트레이션
import journeyStep1Illustration from './illustrations/journey/step1-illustration.svg';
import journeyStep2Illustration from './illustrations/journey/step2-illustration.svg';
import journeyStep3Illustration from './illustrations/journey/step3-illustration.svg';
import journeyStep4Illustration from './illustrations/journey/step4-illustration.svg';
import journeyStep5Illustration from './illustrations/journey/step5-illustration.svg';
import journeyBadgeNumber from './illustrations/journey/badge-number.svg';

// Download 섹션 일러스트레이션
import downloadSpaceBg from './illustrations/download/space-bg.svg';
import downloadSpaceDecor from './illustrations/download/space-decor.svg';
import downloadAppStoreIcon from './illustrations/download/app-store-icon.svg';
import downloadGooglePlayIcon from './illustrations/download/google-play-icon.svg';

// Trust 일러스트레이션
import trustArrowRight from './illustrations/trust/arrow-right.svg';
import trustHandshakeBg from './illustrations/trust/handshake-bg.svg';
import trustHandLeft from './illustrations/trust/hand-left.svg';
import trustHandRight from './illustrations/trust/hand-right.svg';
import trustShieldIcon from './illustrations/trust/shield.svg';

// How to Buy 아이콘
import howtobuyStep1 from './images/icons/howtobuy-step1.svg';
import howtobuyStep2 from './images/icons/howtobuy-step2.svg';
import howtobuyStep3 from './images/icons/howtobuy-step3.svg';

// 기능 아이콘
import encryptionCoreIcon from './icons/features/encryption-core.svg';
import aiRiskAlertsIcon from './icons/features/ai-risk-alerts.svg';
import transparentAuditIcon from './icons/features/transparent-audit.svg';
import tradingEngineIcon from './icons/features/trading-engine.svg';
import under30msIcon from './icons/features/under-30ms.svg';
import uptimeIcon from './icons/features/uptime.svg';
import tradesIcon from './icons/features/trades.svg';
import trustScoreIcon from './icons/features/trust-score.svg';
import globalVolumeIcon from './icons/features/global-volume.svg';
import topGainerIcon from './icons/features/top-gainer.svg';
import topLoserIcon from './icons/features/top-loser.svg';
import marketCapIcon from './icons/features/market-cap.svg';
import securityIcon from './icons/features/security.svg';
import securityDarkIcon from './icons/features/security-dark.svg';
import securityBgIcon from './icons/features/security-bg.svg';
import securityBgDarkIcon from './icons/features/security-bg-dark.svg';
import reliabilityIcon from './icons/features/reliability.svg';
import reliabilityDarkIcon from './icons/features/reliability-dark.svg';
import reliabilityBgIcon from './icons/features/reliability-bg.svg';
import reliabilityBgDarkIcon from './icons/features/reliability-bg-dark.svg';
import transparencyIcon from './icons/features/transparency.svg';
import transparencyDarkIcon from './icons/features/transparency-dark.svg';
import transparencyBgIcon from './icons/features/transparency-bg.svg';
import transparencyBgDarkIcon from './icons/features/transparency-bg-dark.svg';
// Institutional 기능 아이콘
import institutionalSupportIcon from './icons/features/institutional-support.svg';
import institutionalTradingIcon from './icons/features/institutional-trading.svg';
import institutionalToolsIcon from './icons/features/institutional-tools.svg';
import institutionalSecurityIcon from './icons/features/institutional-security.svg';
import institutionalEcosystemIcon from './icons/features/institutional-ecosystem.svg';
import institutionalFeesIcon from './icons/features/institutional-fees.svg';
// Membership Tier 아이콘
import explorerTierIcon from './icons/tiers/explorer-full-icon.svg';
import navigatorTierIcon from './icons/tiers/navigator-icon.svg';
import voyagerTierIcon from './icons/tiers/voyager-icon.svg';
import vipTierIcon from './icons/tiers/vip-icon.svg';
// Navigator 복합 아이콘 요소
import navigatorPolygonBg from './icons/tiers/navigator-polygon-bg.svg';
import navigatorStarsSmall from './icons/tiers/navigator-stars-small.svg';
import navigatorStarRight from './icons/tiers/navigator-star-right-new2.svg';
import navigatorStarLeft from './icons/tiers/navigator-star-left-new2.svg';
// Voyager 복합 아이콘 요소
import voyagerPolygonBg from './icons/tiers/voyager-polygon-bg.svg';
import voyagerStarsGroup from './icons/tiers/voyager-stars-group-new.svg';
import voyagerStarRight from './icons/tiers/voyager-star-right-new2.svg';
import voyagerStarLeft from './icons/tiers/voyager-star-left-new2.svg';
// VIP 복합 아이콘 요소
import vipPolygonBg from './icons/tiers/vip-polygon-bg.svg';
import vipStarRight from './icons/tiers/vip-star-right-new2.svg';
import vipStarLeft from './icons/tiers/vip-star-left-new2.svg';
import vipDiamond from './icons/tiers/vip-diamond-new.svg';
import vipLayer from './icons/tiers/vip-layer-new.svg';
// Requirements Table 아이콘
import tableStarIcon from './icons/tiers/star-icon.svg';
import tableStarIcon2 from './icons/tiers/star-icon-2.svg';
import tableDivider from './icons/tiers/table-divider.svg';
import checkTierStar from './icons/tiers/check-tier-star.svg';
import tableDiamond from './icons/ui/icon-diamond.svg';

// 네비게이션 아이콘 - Details 화살표
import detailsArrowIcon from './icons/navigation/details-arrow.svg';

// 트레이더 관련
import traderAvatar1 from './misc/trader-avatar-1.svg';
import traderAvatar2 from './misc/trader-avatar-2.svg';
import traderGraphBg from './misc/trader-graph-bg.svg';
import traderGraphLine from './misc/trader-graph-line.svg';
import arrowRightWhite from './misc/arrow-right-white.svg';

// 캐러셀 아이콘
import carouselArrowLeft from './icons/arrow-left.svg';
import carouselArrowRight from './icons/arrow-right.svg';
import carouselCheck from './icons/check.svg';
import carouselChartLine from './icons/chart-line.svg';
import carouselChartGradient from './icons/chart-gradient.svg';

// 배경 이미지
export const backgrounds = {
  hero: heroBg,
  heroDark: heroBgDark,
  footer: footerBg,
  footerDark: footerBgDark,
  welcomeBonus: welcomeBonusBg,
  welcomeBonusDark: welcomeBonusBgDark,
  journey: journeyPlanets,
  tradeSeamlessly: tradeSeamlesslyBg,
  marketHeroStars: marketHeroStars,
  marketHeroOrbital: marketHeroOrbital,
  marketHeroAstronaut: marketHeroAstronaut,
  vipSupportPlanetsBg: vipSupportPlanetsBg,
  membershipTierGalaxyLayer1: membershipTierGalaxyLayer1,
  membershipTierGalaxyLayer2: membershipTierGalaxyLayer2,
  membershipTierPlanetsBg: membershipTierPlanetsBg,
  membershipTierUnion: membershipTierUnion,
  requirementsTableUnion: requirementsTableUnion,
  crystalGloss: crystalGloss,
  crystalStone: crystalStone,
};

// 로고
export const logos = {
  piecrip: '/assets/piecrip/logos/piecrip-logo.svg',
  piecripDark: '/assets/piecrip/logos/piecrip-logo-dark.svg',
  piecripFooter: '/assets/piecrip/logos/piecrip-footer-logo.svg',
  piecripFooterDark: '/assets/piecrip/logos/piecrip-footer-logo-dark.svg',
};

// 크립토 아이콘
export const cryptoIcons = {
  btc: btcIcon,
  eth: ethIcon,
  xrp: xrpIcon,
  sol: solIcon,
  doge: dogeIcon,
};

// UI 아이콘
export const uiIcons = {
  message: messageIcon,
  search: searchIcon,
  user: userIcon,
  language: languageIcon,
  download: downloadIcon,
  lightMode: lightModeIcon,
  darkMode: darkModeIcon,
  settings: settingsIcon,
  settingsDark: settingsDarkIcon,
  nightMode: nightModeIcon,
  arrow: arrowIcon,
  check: checkIcon,
  qrCode: qrCodeIcon,
  myRewardsIcon: myRewardsIcon,
  star: starIcon,
  checkBig: checkBigIcon,
  checkBigWhite: checkBigWhiteIcon,
  faqCheckIcon: faqCheckIcon,
  faqLines: faqLines,
  vipDiamondIcon: vipDiamondIcon,
  emailIcon: emailIcon,
  buildingIcon: buildingIcon,
  chatIcon: chatIcon,
  hamburgerMenu: hamburgerMenuIcon,
  graphLine: graphLineIcon,
  arrowRightSmall: arrowRightSmallIcon,
  chevronRight: chevronRightIcon,
  arrowRightCyan: arrowRightCyanIcon,
  scrollArrow: scrollArrowIcon,
  support: supportIcon,
  scrollUp: scrollUpIcon,
};

// 네비게이션 아이콘
export const navIcons = {
  arrowRight: arrowRightIcon,
  arrowIcon: arrowNavIcon,
};

// 파트너 로고
export const partnerLogos = {
  buffer: bufferLogo,
  bufferLight: bufferLogoLight,
  pimcore: pimcoreLogo,
  pimcoreLight: pimcoreLogoLight,
  githubPages: githubPagesLogo,
  githubPagesLight: githubPagesLogoLight,
  coinbase: coinbaseLogo,
  coinbaseLight: coinbaseLogoLight,
  dropbox: dropboxLogo,
  dropboxLight: dropboxLogoLight,
  framer: framerLogo,
  framerLight: framerLogoLight,
  bereal: berealLogo,
  berealLight: berealLogoLight,
  digitalOcean: digitalOceanLogoDark,
  digitalOceanLight: digitalOceanLogo,
};

// 소셜 아이콘
export const socialIcons = {
  facebook: facebookIcon,
  facebookBg: facebookBgIcon,
  facebookOverlay: facebookOverlayIcon,
  x: xIcon,
  instagram: instagramIcon,
  discord: discordIcon,
  youtube: youtubeIcon,
  youtubeBg: youtubeBgIcon,
  youtubeOverlay: youtubeOverlayIcon,
  reddit: redditIcon,
  redditBg: redditBgIcon,
  redditOverlay: redditOverlayIcon,
  tiktok: tiktokIcon,
  frame89: frame89Icon,
  whatsapp: whatsappIcon,
  whatsappBg: whatsappBgIcon,
  whatsappOverlay: whatsappOverlayIcon,
  snapchat: snapchatIcon,
  snapchatBg: snapchatBgIcon,
  snapchatOverlay: snapchatOverlayIcon,
  gamepadBg: gamepadBgIcon,
  gamepadOverlay: gamepadOverlayIcon,
  // 다크모드
  facebookDark: facebookDarkIcon,
  redditDark: redditDarkIcon,
  snapchatDark: snapchatDarkIcon,
  gamepadDark: gamepadDarkIcon,
  youtubeDark: youtubeDarkIcon,
  whatsappDark: whatsappDarkIcon,
};

// 스토어 배지
export const storeBadges = {
  appStore: appStoreBadge,
  googlePlay: googlePlayBadge,
};

// 일러스트레이션
export const illustrations = {
  journeyStep1,
  journeyStep2,
  journeyStep3,
  journeyStep4,
  journeyStep5,
  journeyBadge,
  trustShield,
  trustShieldDark,
  trustVector1,
  trustVector2,
  trustVector3,
  tradeAcrossChart,
  buysellPlanetsBg,
  buysellCharacter,
  buysellVrDevice,
  toptradersAstronaut,
  toptradersFlag,
  toptradersTrophyLogo,
  toptradersPlanetsBg,
  institutionalHeroBg,
  heroAstronaut,
  heroAstronautDark,
  heroPlanets,
  chartDots,
  chartDotsDark,
  bonusAstronaut,
  bonusPlanetsBg,
  rank1Ring,
  rank1Laurel,
  rank1Badge,
  rank1Profile,
  rank2Ring,
  rank2Laurel,
  rank2Badge,
  rank2Profile,
  rank3Ring,
  rank3Laurel,
  rank3Badge,
  rank3Profile,
};

// How to Buy 아이콘
export const howtobuyIcons = {
  step1: howtobuyStep1,
  step2: howtobuyStep2,
  step3: howtobuyStep3,
};

// 기능 아이콘
export const featureIcons = {
  encryptionCore: encryptionCoreIcon,
  aiRiskAlerts: aiRiskAlertsIcon,
  transparentAudit: transparentAuditIcon,
  tradingEngine: tradingEngineIcon,
  under30ms: under30msIcon,
  uptime: uptimeIcon,
  trades: tradesIcon,
  trustScore: trustScoreIcon,
  globalVolume: globalVolumeIcon,
  topGainer: topGainerIcon,
  topLoser: topLoserIcon,
  marketCap: marketCapIcon,
  security: securityIcon,
  securityDark: securityDarkIcon,
  securityBg: securityBgIcon,
  securityBgDark: securityBgDarkIcon,
  reliability: reliabilityIcon,
  reliabilityDark: reliabilityDarkIcon,
  reliabilityBg: reliabilityBgIcon,
  reliabilityBgDark: reliabilityBgDarkIcon,
  transparency: transparencyIcon,
  transparencyDark: transparencyDarkIcon,
  transparencyBg: transparencyBgIcon,
  transparencyBgDark: transparencyBgDarkIcon,
  // Institutional 아이콘
  institutionalSupport: institutionalSupportIcon,
  institutionalTrading: institutionalTradingIcon,
  institutionalTools: institutionalToolsIcon,
  institutionalSecurity: institutionalSecurityIcon,
  institutionalEcosystem: institutionalEcosystemIcon,
  institutionalFees: institutionalFeesIcon,
  detailsArrow: detailsArrowIcon,
  // Membership Tier 아이콘
  explorerTier: explorerTierIcon,
  navigatorTier: navigatorTierIcon,
  voyagerTier: voyagerTierIcon,
  vipTier: vipTierIcon,
  diamond: vipTierIcon,
  // Navigator 복합 아이콘 요소
  navigatorPolygonBg: navigatorPolygonBg,
  navigatorStarsSmall: navigatorStarsSmall,
  navigatorStarRight: navigatorStarRight,
  navigatorStarLeft: navigatorStarLeft,
  // Voyager 복합 아이콘 요소
  voyagerPolygonBg: voyagerPolygonBg,
  voyagerStarsGroup: voyagerStarsGroup,
  voyagerStarRight: voyagerStarRight,
  voyagerStarLeft: voyagerStarLeft,
  // VIP 복합 아이콘 요소
  vipPolygonBg: vipPolygonBg,
  vipStarRight: vipStarRight,
  vipStarLeft: vipStarLeft,
  vipDiamond: vipDiamond,
  vipLayer: vipLayer,
  // Requirements Table 아이콘
  tableStarIcon: tableStarIcon,
  tableStarIcon2: tableStarIcon2,
  tableDivider: tableDivider,
  checkTierStar: checkTierStar,
  tableDiamond: tableDiamond,
  // FAQ 아이콘
  faqCheckIcon: faqCheckIcon,
  faqLines: faqLines,
  // VIP Support 아이콘
  emailIcon: emailIcon,
  buildingIcon: buildingIcon,
  chatIcon: chatIcon,
  // UI 아이콘 (추가)
  vipDiamondIcon: vipDiamondIcon,
  checkBig: checkBigIcon,
  myRewardsIcon: myRewardsIcon,
};

// 트레이더 관련
export const traderAssets = {
  avatar1: traderAvatar1,
  avatar2: traderAvatar2,
  graphBg: traderGraphBg,
  graphLine: traderGraphLine,
  arrowRightWhite,
};

// 캐러셀 아이콘
export const carouselIcons = {
  arrowLeft: carouselArrowLeft,
  arrowRight: carouselArrowRight,
  check: carouselCheck,
  chartLine: carouselChartLine,
  chartGradient: carouselChartGradient,
};

// Sentiment 일러스트레이션
export const sentimentIllustrations = {
  planetsBg: sentimentPlanetsBg,
  cockpitFrame: sentimentCockpitFrame,
  crystal: sentimentCrystal,
  gaugeSubtractBg: sentimentGaugeSubtractBg,
  controlPanelLeft: sentimentControlPanelLeft,
  controlPanelRight: sentimentControlPanelRight,
  moonPlanet: sentimentMoonPlanet,
  smallCrystal: sentimentSmallCrystal,
  gaugeLeftDiamond: sentimentGaugeLeftDiamond,
  gaugeOuterArc: sentimentGaugeOuterArc,
  gaugeInnerArc: sentimentGaugeInnerArc,
  gaugeRightDiamond: sentimentGaugeRightDiamond,
  gaugeTopArc: sentimentGaugeTopArc,
  gaugeCenterLine: sentimentGaugeCenterLine,
  gaugeLeftSide: sentimentGaugeLeftSide,
  gaugeBottomArc: sentimentGaugeBottomArc,
  gaugeNeedle: sentimentGaugeNeedle,
  binanceCircle: sentimentBinanceCircle,
  circleRing: sentimentCircleRing,
  litecoinIcon: sentimentLitecoinIcon,
  btcIcon: sentimentBtcIcon,
  // Graphs
  pulseFill: sentimentPulseFill,
  pulseLine: sentimentPulseLine,
  socialMediaBars: socialMediaBars,
  moodShiftLines: moodShiftLines,
};

// Journey Universe 일러스트레이션
export const journeyIllustrations = {
  step1: journeyStep1Illustration,
  step2: journeyStep2Illustration,
  step3: journeyStep3Illustration,
  step4: journeyStep4Illustration,
  step5: journeyStep5Illustration,
  badgeNumber: journeyBadgeNumber,
};

// Trust 섹션 일러스트레이션
export const trustIllustrations = {
  arrowRight: trustArrowRight,
  handshakeBg: trustHandshakeBg,
  handLeft: trustHandLeft,
  handRight: trustHandRight,
  shield: trustShieldIcon,
};

// Download 섹션 일러스트레이션
export const downloadIllustrations = {
  spaceBg: downloadSpaceBg,
  spaceDecor: downloadSpaceDecor,
  appStoreIcon: downloadAppStoreIcon,
  googlePlayIcon: downloadGooglePlayIcon,
};

